<template>
  <app-modal
    v-model="isDialogOpened"
    :ok-text="$t('project.nda.dialogs.NdaAddedSignDialog.confirmText').toString()"
    :cancel-text="$t('project.nda.dialogs.NdaAddedSignDialog.cancelText').toString()"
    size="md"
    @ok="signNda"
    @cancel="$router.push('/')"
  >
    <template #title>
      {{ $t('project.nda.dialogs.NdaAddedSignDialog.title') }}
    </template>
    <template #body>
      <p>{{ $t('project.nda.dialogs.NdaAddedSignDialog.confirmedAction') }}</p>
      <p>{{ $t('project.nda.dialogs.NdaAddedSignDialog.actionIncentive') }}</p>
    </template>
  </app-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import { dialogMixin } from '@/mixins/dialogMixin'
import { NDA_SIGNING_VIEW_ROUTE_NAME } from '@/router/routerData'

export default defineComponent({
  name: 'NdaAddedSignDialog',
  mixins: [dialogMixin],
  props: {
    mnemo: {
      type: String,
      required: true,
    },
  },
  methods: {
    signNda () {
      this.$router.push({
        name: NDA_SIGNING_VIEW_ROUTE_NAME,
        params: {
          mnemo: this.mnemo,
        },
      })
    },
  },
})
</script>
